

/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as ResponsesRoleTypes from '../responses-roles/types'
import * as SchemaTypes from '../schema/types'

import * as UserTypes from "./types"

export type UsersGetKey = ['users',unknown];

export type UsersGetResponse = UserTypes.ResponseUsersPaging;

export type UsersGetVariables = {
    body?: void;
    query?: {
        sortBy?: Array<string>;
        userType?: SchemaTypes.UserType;
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        endingBefore?: string;
    };
}

export const usersGet = makeData<
  UsersGetResponse,
  UsersGetKey,
  UsersGetVariables
>({
  method: 'get',
  name: 'usersGet',
  summary: "Get users",
  path: '/users',
  queryKey: ({query, }) => ['users', query],
})

export type UserCreateKey = ['users',unknown];

export type UserCreateResponse = UserTypes.ResponseUser;

export type UserCreateVariables = {
    body?: UserTypes.UserCreate;
    query?: void;
}

export const userCreate = makeData<
  UserCreateResponse,
  UserCreateKey,
  UserCreateVariables
>({
  method: 'post',
  name: 'userCreate',
  summary: "Create user",
  path: '/users',
  queryKey: ({query, }) => ['users', query],
})

export type UserGetKey = ['users',string | undefined,unknown];

export type UserGetResponse = UserTypes.ResponseUser;

export type UserGetVariables = {
    userId: string | undefined;
    body?: void;
    query?: void;
}

export const userGet = makeData<
  UserGetResponse,
  UserGetKey,
  UserGetVariables
>({
  method: 'get',
  name: 'userGet',
  summary: "Get user",
  path: '/users/{userId}',
  queryKey: ({query, userId,}) => ['users',userId, query],
})

export type UserUpdateKey = ['users',string | undefined,unknown];

export type UserUpdateResponse = UserTypes.ResponseUser;

export type UserUpdateVariables = {
    userId: string | undefined;
    body?: UserTypes.UserUpdate;
    query?: void;
}

export const userUpdate = makeData<
  UserUpdateResponse,
  UserUpdateKey,
  UserUpdateVariables
>({
  method: 'put',
  name: 'userUpdate',
  summary: "Update user",
  path: '/users/{userId}',
  queryKey: ({query, userId,}) => ['users',userId, query],
})

export type UserRoleGetKey = ['users',string | undefined,'roles',unknown];

export type UserRoleGetResponse = ResponsesRoleTypes.RolesPaging;

export type UserRoleGetVariables = {
    userId: string | undefined;
    body?: void;
    query?: {
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        endingBefore?: string;
    };
}

export const userRoleGet = makeData<
  UserRoleGetResponse,
  UserRoleGetKey,
  UserRoleGetVariables
>({
  method: 'get',
  name: 'userRoleGet',
  summary: "Get user roles",
  path: '/users/{userId}/roles',
  queryKey: ({query, userId,}) => ['users',userId,'roles', query],
})

export type UserRoleUpdateKey = ['users',string | undefined,'roles',string | undefined,unknown];

export type UserRoleUpdateResponse = void;

export type UserRoleUpdateVariables = {
    userId: string | undefined;
    roleId: string | undefined;
    body?: void;
    query?: void;
}

export const userRoleUpdate = makeData<
  UserRoleUpdateResponse,
  UserRoleUpdateKey,
  UserRoleUpdateVariables
>({
  method: 'put',
  name: 'userRoleUpdate',
  summary: "Add role to user",
  path: '/users/{userId}/roles/{roleId}',
  queryKey: ({query, userId,
roleId,}) => ['users',userId,'roles',roleId, query],
})

export type UserRoleDeleteKey = ['users',string | undefined,'roles',string | undefined,unknown];

export type UserRoleDeleteResponse = void;

export type UserRoleDeleteVariables = {
    userId: string | undefined;
    roleId: string | undefined;
    body?: void;
    query?: void;
}

export const userRoleDelete = makeData<
  UserRoleDeleteResponse,
  UserRoleDeleteKey,
  UserRoleDeleteVariables
>({
  method: 'delete',
  name: 'userRoleDelete',
  summary: "Remove role from user",
  path: '/users/{userId}/roles/{roleId}',
  queryKey: ({query, userId,
roleId,}) => ['users',userId,'roles',roleId, query],
})

export type UserGetPermissionsKey = ['users',string | undefined,'permissions',unknown];

export type UserGetPermissionsResponse = void;

export type UserGetPermissionsVariables = {
    userId: string | undefined;
    body?: void;
    query?: void;
}

export const userGetPermissions = makeData<
  UserGetPermissionsResponse,
  UserGetPermissionsKey,
  UserGetPermissionsVariables
>({
  method: 'get',
  name: 'userGetPermissions',
  summary: "Get user's current permissions",
  path: '/users/{userId}/permissions',
  queryKey: ({query, userId,}) => ['users',userId,'permissions', query],
})

export type InternalUsersGetKey = ['companies',string | undefined,'users',unknown];

export type InternalUsersGetResponse = UserTypes.ResponseUsersPaging;

export type InternalUsersGetVariables = {
    companyId: string | undefined;
    body?: void;
    query?: {
        sortBy?: Array<string>;
        userType?: SchemaTypes.UserType;
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        endingBefore?: string;
    };
}

export const internalUsersGet = makeData<
  InternalUsersGetResponse,
  InternalUsersGetKey,
  InternalUsersGetVariables
>({
  method: 'get',
  name: 'internalUsersGet',
  summary: "Get a company's users",
  path: '/companies/{companyId}/users',
  queryKey: ({query, companyId,}) => ['companies',companyId,'users', query],
})

export type InternalUserCreateKey = ['companies',string | undefined,'users',unknown];

export type InternalUserCreateResponse = UserTypes.ResponseUser;

export type InternalUserCreateVariables = {
    companyId: string | undefined;
    body?: UserTypes.UserCreate;
    query?: void;
}

export const internalUserCreate = makeData<
  InternalUserCreateResponse,
  InternalUserCreateKey,
  InternalUserCreateVariables
>({
  method: 'post',
  name: 'internalUserCreate',
  summary: "Create company user",
  path: '/companies/{companyId}/users',
  queryKey: ({query, companyId,}) => ['companies',companyId,'users', query],
})

export type InternalUserGetKey = ['companies',string | undefined,'users',string | undefined,unknown];

export type InternalUserGetResponse = UserTypes.ResponseUser;

export type InternalUserGetVariables = {
    companyId: string | undefined;
    userId: string | undefined;
    body?: void;
    query?: void;
}

export const internalUserGet = makeData<
  InternalUserGetResponse,
  InternalUserGetKey,
  InternalUserGetVariables
>({
  method: 'get',
  name: 'internalUserGet',
  summary: "Get company user",
  path: '/companies/{companyId}/users/{userId}',
  queryKey: ({query, companyId,
userId,}) => ['companies',companyId,'users',userId, query],
})

export type InternalUserUpdateKey = ['companies',string | undefined,'users',string | undefined,unknown];

export type InternalUserUpdateResponse = UserTypes.ResponseUser;

export type InternalUserUpdateVariables = {
    companyId: string | undefined;
    userId: string | undefined;
    body?: UserTypes.UserUpdate;
    query?: void;
}

export const internalUserUpdate = makeData<
  InternalUserUpdateResponse,
  InternalUserUpdateKey,
  InternalUserUpdateVariables
>({
  method: 'put',
  name: 'internalUserUpdate',
  summary: "Update company user",
  path: '/companies/{companyId}/users/{userId}',
  queryKey: ({query, companyId,
userId,}) => ['companies',companyId,'users',userId, query],
})

export type InternalUserGetPermissionsKey = ['companies',string | undefined,'users',string | undefined,'permissions',unknown];

export type InternalUserGetPermissionsResponse = void;

export type InternalUserGetPermissionsVariables = {
    companyId: string | undefined;
    userId: string | undefined;
    body?: void;
    query?: void;
}

export const internalUserGetPermissions = makeData<
  InternalUserGetPermissionsResponse,
  InternalUserGetPermissionsKey,
  InternalUserGetPermissionsVariables
>({
  method: 'get',
  name: 'internalUserGetPermissions',
  summary: "Get user permissions",
  path: '/companies/{companyId}/users/{userId}/permissions',
  queryKey: ({query, companyId,
userId,}) => ['companies',companyId,'users',userId,'permissions', query],
})

export type InternalUserRoleGetKey = ['companies',string | undefined,'users',string | undefined,'roles',unknown];

export type InternalUserRoleGetResponse = ResponsesRoleTypes.RolesPaging;

export type InternalUserRoleGetVariables = {
    companyId: string | undefined;
    userId: string | undefined;
    body?: void;
    query?: {
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        endingBefore?: string;
    };
}

export const internalUserRoleGet = makeData<
  InternalUserRoleGetResponse,
  InternalUserRoleGetKey,
  InternalUserRoleGetVariables
>({
  method: 'get',
  name: 'internalUserRoleGet',
  summary: "Get roles by user",
  path: '/companies/{companyId}/users/{userId}/roles',
  queryKey: ({query, companyId,
userId,}) => ['companies',companyId,'users',userId,'roles', query],
})

export type InternalUserRoleUpdateKey = ['companies',string | undefined,'users',string | undefined,'roles',string | undefined,unknown];

export type InternalUserRoleUpdateResponse = void;

export type InternalUserRoleUpdateVariables = {
    companyId: string | undefined;
    userId: string | undefined;
    roleId: string | undefined;
    body?: void;
    query?: void;
}

export const internalUserRoleUpdate = makeData<
  InternalUserRoleUpdateResponse,
  InternalUserRoleUpdateKey,
  InternalUserRoleUpdateVariables
>({
  method: 'put',
  name: 'internalUserRoleUpdate',
  summary: "Add role to user",
  path: '/companies/{companyId}/users/{userId}/roles/{roleId}',
  queryKey: ({query, companyId,
userId,
roleId,}) => ['companies',companyId,'users',userId,'roles',roleId, query],
})

export type InternalUserRoleDeleteKey = ['companies',string | undefined,'users',string | undefined,'roles',string | undefined,unknown];

export type InternalUserRoleDeleteResponse = void;

export type InternalUserRoleDeleteVariables = {
    companyId: string | undefined;
    userId: string | undefined;
    roleId: string | undefined;
    body?: void;
    query?: void;
}

export const internalUserRoleDelete = makeData<
  InternalUserRoleDeleteResponse,
  InternalUserRoleDeleteKey,
  InternalUserRoleDeleteVariables
>({
  method: 'delete',
  name: 'internalUserRoleDelete',
  summary: "Remove role from user",
  path: '/companies/{companyId}/users/{userId}/roles/{roleId}',
  queryKey: ({query, companyId,
userId,
roleId,}) => ['companies',companyId,'users',userId,'roles',roleId, query],
})
